import React, { useEffect, useRef, useState } from "react";
import JobRole from "../components/JobRole/JobRole";
import MultiStepper from "../components/mutli-stepper/MultiStepper";
import InfiniteScroll from "react-infinite-scroll-component";
import SlideOver from "../components/slideover/slideover";
import { Link } from "react-router-dom";
import Header from "../templates/Header/Header";
import { randomUUID } from "../utils/randomUUID";
import { explrRols, suggestedRols } from "../selectors/explore-roles";
import { useRecoilValue } from "recoil";
import { groupBy } from "./PresentationServices";
import { userDataState } from "../atoms/dashboard";
import { driver } from "driver.js";
import { MycarUrl } from "../selectors/baseurl";
const JourneyMap = ({
  showJourneyMap,
  setShowJourneyMap,
  isGridRow,
  isDetailsRequired,
}) => {
  const suggestedRolsData = useRecoilValue(suggestedRols);
  const explrRolsData = useRecoilValue(explrRols);
  const usrData = useRecoilValue(userDataState);
  console.log(explrRolsData);
  const grpRols = groupBy(["mappingId"]);
 if (usrData?.isLogged == false) window.location.href = MycarUrl;// 
  //const grpLevel=groupBy(['levals']);
  let resData1 =
    suggestedRolsData != "No record found" ? grpRols(suggestedRolsData) : [];
  console.log("grped data", resData1);
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: ".job-role-main",
        popover: {
          title: "Top 4 suggested move",
          description:
            "<p> This feature provides the Top 4 suggested jobs at RRD (Within and Other Division) based on your Skills and Experience By clicking on details in the each card, the system will display the respective Jobs Role Info and Skill Sets</p>",
        },
      },
      {
        element: ".prisecskills",
        popover: {
          title: "Primary Skills and Secondary Skills",
          description:
            "<p>Here are your Skill Sets and its proficiency details, if required please update your skills in MySkill Portal</p>",
        },
      },
      {
        element: ".ceretCls",
        popover: {
          title: "My Certification",
          description:
            "<p>Your Certificate details can be seen here, if required please update your skills in MySkill Portal </p>",
        },
      },
      {
        element: ".explrbtn",
        popover: {
          title: "Job wheel",
          description:
            "<p>Explore - Click the button to explore the suggested roles at RRD</p>",
        },
      },
    ],
  });
  function initialData() {
    console.log("newJourneyMapData", resData1);
    let newJourneyMapData1 = Object.values(explrRolsData).map((data) => {
      console.log("dataaa", data);
      return {
        ...data,
        levels: [data].map((vals) => {
          console.log("vals", vals);
          let newdata = "";
          if (Object.keys(resData1).includes(vals?.jdmMappingId)) {
            newdata = resData1[vals?.jdmMappingId].map((val) => {
              return { levals: val.jobLevelName, levl_vals: val.jobTitleName };
            });
            return newdata;
          } else {
            newdata = [];
            return newdata;
          }
        }),
      };
    });

    return newJourneyMapData1;
  }
  const [data, setData] = useState(initialData);

  const closeRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const closeModal = () => {
    // if(closeRef.current){
    // closeRef.current.children[0].classList.add('hidden');
    setShowJourneyMap(false);
    // }
    // closeRef.current.querySelector(".slideover")?.classList?.add("hidden");
  };

  return (
    <>
      {/* {showJourneyMap && <SlideOver isJourneyMapPage={true} ref={closeRef} showJourneyMap={showJourneyMap} > */}
      <div className="mx-auto h-full w-full">
        <div className="main-section">
          <Header />
          <main>
            <div>
              <div className="flex items-center justify-between p-6">
                <div className="breadcrumb">
                  {/* <span className="text-center inline-block ml-[16px] font-bold opacity-50">
                RRD
              </span> */}
                  <h2 className="ml-0 text-[16px] text-[#033d9b] tracking-[2px] font-extrabold uppercase">
                    <Link to="/dashboard">Dashboard</Link> /{" "}
                    <Link to="/explore-roles">Compactable Streams/Roles</Link> / SUGGESTED
                    MOVES JOURNEY MAP
                  </h2>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <span className="inline-block h-3 w-3 bg-[#478efd] rounded-sm"></span>
                    <h3 className="text-[#312424]">CURRENT DIVISION</h3>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="inline-block h-3 w-3 bg-[#c9407f] rounded-sm"></span>
                    <h3 className="text-[#312424]">OTHER DIVISION</h3>
                  </div>
                  {/* <Link to='/explore-roles'>
                <div className="cursor-pointer" onClick={closeModal}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.824" fill="#ff0f0f" stroke="#fff" strokeWidth='0.7px' height="12.824" viewBox="0 0 12.824 12.824">
                    <path id="Icon_material-outline-close" data-name="Icon material-outline-close" className="cls-1" d="M19.334,8.692,18.143,7.5l-4.725,4.725L8.692,7.5,7.5,8.692l4.725,4.725L7.5,18.143l1.192,1.192,4.725-4.725,4.725,4.725,1.192-1.192-4.725-4.725Z" transform="translate(-7.005 -7.005)" />
                  </svg>
                </div>
              </Link> */}
                </div>
              </div>

              <div className="explore-journey-map flex gap-8 bg-white">
                <div className="explore-oppr row-span-1">
                  <div
                    className={`${
                      isGridRow
                        ? "px-20 py-0 rounded-2xl"
                        : "px-15 py-5 ml-5 rounded-2xl"
                    }`}
                  >
                    <div
                      className={`${
                        isGridRow
                          ? `grid grid-cols-4 gap-4 `
                          : "grid grid-rows-4 gap-8 bg-white"
                      } job-role-main`}
                    >
                      {explrRolsData.map((val, _, arr) => {
                        return (
                          <JobRole
                            key={randomUUID()}
                            data={val}
                            isDetailsRequired={isDetailsRequired}
                            valsid={val.id}
                            arr={arr}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="col-span-9 journeymap-right-side">
                  <div className="bg-white flex flex-col gap-8 justify-evenly py-5 ">
                    {console.log("my_lat_val_pras", data)}
                    {data.map((val) => {
                      return <MultiStepper data={val} key={randomUUID()} />;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {/* </SlideOver>} */}
    </>
  );
};

export default JourneyMap;
